module.exports = __webpack_public_path__ + "img/public/SiteIcons/priceIcon.svg?86bb2678";